module.exports = __webpack_public_path__ + "img/bar-chart-09.48a31ec6.svg";